module.exports = __webpack_public_path__ + "static/why-wont-you-apologize-b710ea95b1b8503a3a5f3ebfc85adc51.jpg";